import React from 'react';
import styled from 'styled-components';
import { grey } from 'sushiweb/tokens/color';
import { help } from '../../../images/images';
import './HelpButton.scss';

const mode = window.dashboard.mode;

export const HelpButton = ({ orderId = null, handleOpen, userId = null }) => {
  return (
    <HelpButton.Container
      mode={mode}
      borderColor={grey.z500}
      onClick={() => handleOpen(orderId || userId)}
    >
      <img className='icon' src={help} alt='' />
      <HelpButton.Label>Help</HelpButton.Label>
    </HelpButton.Container>
  );
};

HelpButton.Container = styled.div`
  border-radius: 4.4rem;
  padding: 0.6rem 0.5rem;
  border-width: 0.03rem;
  border-style: solid;
  border-color: ${(props) => props.borderColor ?? '#9c9c9c'};
  cursor: pointer;
  justify-content: center;
  align-self: ${(props) =>
    props.mode === 'smartplug' ? 'center' : 'flex-start'};
  height: 2.6rem;
  width: 6rem;
  margin-right: 0.7rem;
`;

HelpButton.Label = styled.div`
  align-items: center;
  font-size: 1.2rem;
  margin-left: 0.3rem;
`;

HelpButton.defaultProps = {
  orderId: null,
  handleOpen: (orderId) => {},
};

export default HelpButton;
